var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-history my-2"},[_c('logList',{ref:"logList",attrs:{"isModal":false,"reqPath":("user/history/list/" + (this.$route.params.api_id)),"perPage":10,"headers":_vm.tableHeaders}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }